import { render, staticRenderFns } from "./UserCardDetails.vue?vue&type=template&id=9c4c30e6"
import script from "./UserCardDetails.vue?vue&type=script&lang=js"
export * from "./UserCardDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports